import { render, staticRenderFns } from "./subcategoriaproducto.vue?vue&type=template&id=7199023e&"
import script from "./subcategoriaproducto.vue?vue&type=script&lang=js&"
export * from "./subcategoriaproducto.vue?vue&type=script&lang=js&"
import style0 from "./subcategoriaproducto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports